import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { useReducer } from 'react';
import merge from 'lodash.merge';
import Context from '../context';
import { modes } from '../constants';
import { jsx as ___EmotionJSX } from "@emotion/core";

var reducer = function reducer(state, next) {
  return typeof next === 'function' ? merge({}, state, next(state)) : merge({}, state, next);
};

export default (function (props) {
  var _useReducer = useReducer(reducer, {
    mode: modes.normal,
    step: 0,
    metadata: {}
  }),
      state = _useReducer[0],
      setState = _useReducer[1];

  var register = function register(index, key, value) {
    var _index, _metadata;

    if (state.metadata[index] && state.metadata[index][key]) return;
    setState({
      metadata: (_metadata = {}, _metadata[index] = (_index = {}, _index[key] = value, _index), _metadata)
    });
  };

  var context = _objectSpread({}, state, {
    setState: setState,
    register: register
  });

  return ___EmotionJSX(Context.Provider, {
    value: context
  }, props.children);
});